import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { ApiErrorResponse } from 'src/app/shared/interfaces/api-error-response';
import { phoneNumberValidator } from 'src/app/shared/validators/phone-number.validator';
import { taxNumberValidator } from 'src/app/shared/validators/tax-number.validator';
import { SubSink } from 'subsink';

import { environment } from '@environments/environment';
import { trimInput } from '@shared/helpers/input-trim-helper';
import { isValidEmail } from '@shared/validators/email.validator';

@Component({
  selector: 'app-merchant-registration-form',
  templateUrl: './merchant-registration-form.component.html',
  styleUrls: ['./merchant-registration-form.component.scss'],
})
export class MerchantRegistrationFormComponent implements OnDestroy {
  @Output() continue = new EventEmitter();
  @Input() isLoading?: boolean | null;
  @Input() errorResponse?: ApiErrorResponse | null;

  documentsStorageUrl = environment.documentsStorageUrl;

  private subs = new SubSink();

  TITLE = 'REGISTRATION.TITLE.';
  PLACEHOLDER = 'REGISTRATION.PLACEHOLDER.';

  registrationForm: UntypedFormGroup = this.fb.group({
    companyName: new UntypedFormControl(null, [Validators.required]),
    brandName: new UntypedFormControl(null, [Validators.required]),
    taxNumber: new UntypedFormControl(null, [
      Validators.required,
      taxNumberValidator,
    ]),
    email: new UntypedFormControl(null, [Validators.required, isValidEmail]),
    phone: new UntypedFormControl(null, [
      Validators.required,
      phoneNumberValidator,
    ]),
    promotionCode: new UntypedFormControl(null, []),
    termsAndConditions: new UntypedFormControl(false, Validators.requiredTrue),
    privacyConditions: new UntypedFormControl(false, Validators.requiredTrue),
    tacAndPrivacy: new UntypedFormControl(null),
  });

  constructor(private fb: UntypedFormBuilder) {}

  onSubmit(): void {
    if (this.registrationForm.valid) {
      if (
        this.registrationForm.get('termsAndConditions')?.value &&
        this.registrationForm.get('privacyConditions')?.value
      ) {
        this.registrationForm.get('tacAndPrivacy')?.setValue(true);
      }
      this.continue.emit(trimInput(this.registrationForm.value));
    } else {
      this.registrationForm.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
